import CheckInIcon from "@/assets/icons/CheckInFlowIcon.svg";
import LoginIcon from "@/assets/icons/LoginFlowIcon.svg";
import RosterIcon from "@/assets/icons/RosterFlowIcon.svg";
import SubmitIcon from "@/assets/icons/SubmitFlowIcon.svg";
import React from "react";
import { Button } from "../ui/button";
import { FlowEnums } from "@/central-atoms/everest-fleet-pwa/enums";

type FlowTypes = FlowEnums;

interface DriverFlowButtonProps {
    text: string;
    iconType: FlowTypes;
    onClick: React.MouseEventHandler<HTMLButtonElement> ;
    disabled?: boolean;
}

const DriverFlowButton: React.FC<DriverFlowButtonProps> = ({ text, iconType, disabled = false, onClick }) => {
    const bgColorClass = disabled ? 'bg-[#ECECEC]' : 'bg-main';
    const cardShadowClass = disabled ? 'border-[#BABABA]' : 'border-primary';
    const cardBorderColorClass = disabled ? 'shadow-[0px_2px_0px_#BABABA]' : 'shadow-[0px_2px_0px_#3EBEC8]';
    const iconContainerClass = disabled ? 'bg-[#BABABA]' : 'bg-secondary';
    const fontColorClass = disabled ? 'text-[#8c8c8c]' : 'text-primary';

    let icon = CheckInIcon;

    if (iconType === FlowEnums.LOGIN) {
        icon = LoginIcon
    }
    else if (iconType === FlowEnums.ROSTER) {
        icon = RosterIcon
    }
    else if (iconType === FlowEnums.SUBMIT) {
        icon = SubmitIcon
    }

    return (
        <Button className="w-max h-max p-0" disabled={disabled} onClick={onClick}>
            <div className={`${bgColorClass} ${cardShadowClass} ${cardBorderColorClass} rounded-[20px] w-[122px] box-border overflow-hidden flex flex-col items-start justify-start py-[13px] px-[17px] text-left text-secondary border-2 border-solid`}>
                <div className="w-full flex items-center justify-center">
                    <div className={`${iconContainerClass} flex items-center justify-center w-[31px] h-[31px] rounded-full`}>
                        <img
                            className="overflow-hidden shrink-0"
                            alt="Icon"
                            src={icon}
                        />
                    </div>
                </div>
                <div className="flex items-end justify-center w-full h-[30px]">
                    <div className={`leading-[17px] font-medium ${fontColorClass}`}>
                        <p className="m-0">{text}</p>
                    </div>
                </div>
            </div>
        </Button>
    );
};

export default DriverFlowButton;
